<script>
import { useSound } from '@vueuse/sound'
import { inventoryMethods, warehouseMethods } from '@state/helpers'
import { mapGetters } from 'vuex'
import { StreamBarcodeReader, ImageBarcodeReader } from 'vue-barcode-reader'
import beep from '@assets/beep.mp3'

export default {
  name: 'QrCounter',
  components: { StreamBarcodeReader, ImageBarcodeReader },
  setup() {
    const audio = useSound(beep)
    return {
      audio,
    }
  },
  data() {
    return {
      modalQrShow: false,
      serial_input: '',
      batch_found_by_serial: '',
      serial_index: 0,
      serial_found: false,
      item_found_by_serial: '',
      searching_serial: false,
      qr_code: '',
      scan: false,
      qr: {
        text: '',
      },
      countError: 0,
      last_serial_input: '',
      manualSerials: [
        'U020693698297',
        'U020743715080',
        '68725+15.0026',
        '2069549+15.5017',
        '2073551+17.50 31',
        '2074393+19.0016',
        '2073596+19.50 43',
        '2074045+20.0025',
        '2074045+20.0026',
        '2074045+20.0027',
        '2074045+20.0031',
        '2074045+20.004',
        '2073598+20.50 57',
        '2073598+20.50 68',
        '2073598+20.50 74',
        '2074048+20.5010',
        '2074048+20.5073',
        '2075038+21.5024',
        '2073603+22.0084',
        '2073604+22.5057',
        '2073604+22.5064',
        '2073604+22.5085',
        '2073604+22.5088',
        '2073605+23.0070',
        '2074096+23.5014',
        '2074096+23.50 45',
        '2074899+24.5006',
        '2072222+26.0015',
        '2075294+26.5035',
        '208013315+30.00',
        '2077078+20.5048',
        '36284+22.5022',
        '2076020+16.5001',
        '2076533+18.5079',
        '2075026+19.5075',
        '2075033+21.0065',
        '2061962+22.0010',
        '2073794+24.00 31',
        '2075922+4.0002',
        '2076310+5.0011',
        '2074830+9.0013',
        '2075535+20.0007',
        '2CM80511',
        '2CM80E81',
        '2CM80M05',
        '2CM902S6',
      ],
      manualSerials: ['U020673608801'],
      manualSerialsCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      inventory: 'retina/inventory/inventory',
      stock: 'retina/inventory/stock',
      inventory_count_mode: 'retina/inventory/inventory_count_mode',
    }),
  },
  methods: {
    ...inventoryMethods,
    ...warehouseMethods,
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
      this.qr.text = text
      this.serial_input = this.qr.text.split(',')[0]
      this.last_serial_input = this.serial_input
      this.audio.play()
      if (this.serial_input) {
        this.addItemInStockBySerialProccess()
      }
    },
    addManualSerial(){
      this.serial_input = this.manualSerials[this.manualSerialsCount];
      this.manualSerialsCount++;
      this.audio.play()
      if(this.manualSerialsCount <= this.manualSerials.length){
        this.addItemInStockBySerialProccess();
      }
    },
    onLoaded() {
      // console.log(`Ready to start scanning barcodes`)
      this.scan = true
    },
    resetModalQr() {
      this.scan = false
      this.qr.text = ''
    },
    async addItemInStockBySerialProccess() {
      await this.findSerial(this.inventory)
      if (this.serial_found) {
        this.addItemInStockBySerial({
          item: this.item_found_by_serial,
          batch: this.batch_found_by_serial,
          assurance: this.serial_index,
          serial: this.serial_input,
        })
        this.$generate_toast(this, 'success', 'Item agregado')
      } else {
        this.findSerial(this.stock)
        if (this.serial_found)
          this.$generate_toast(this, 'info', 'Este Item ya ha sido agregado')
        else {
          if (this.serial_input == this.last_serial_input) {
            this.countError += 1
            if (this.countError > 1) {
              this.modalQrShow = false
              this.countError = 0
              this.serial_input = ''
            }
          }
          this.$generate_toast( this, 'error', 'No se encuentra Item con Serial: ' + this.serial_input )
        }
      }
      this.serial_input = ''
    },
    findSerial(list) {
      this.searching_serial = true
      this.serial_found = false
      this.batch_found_by_serial = ''
      this.item_found_by_serial = ''
      if (this.serial_input.trim() == '') {
        this.$refs['serial_input'].focus()
        return
      }
      let context = this
      if (context.serial_input.length > 20){
        // hoya:
        if(context.serial_input.substr(24,2) === '21' && context.serial_input.length === 34){
          context.serial_input = context.serial_input.substr(26)
        // hanita:
        } else if(context.serial_input.substr(37,2) === '21' && context.serial_input.indexOf("240¡") > 0){
          let parts = context.serial_input.substr(39).split('240¡')
          context.serial_input = parts[0].substr(0, parts[0].length-2) + '+' + parts[1].substr(0, parts[1].length-1) + ' ' + parts[0].substr(-2)
          // datamatrix - negative power (march/2023)
        } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[-])/) > 0){
          let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[-])/)
          context.serial_input = parts[0] + '-' + parts[2]
        // datamatrix (jan/2023)
        } else if(context.serial_input.substr(24,2) === '21' && context.serial_input.search(/(10[A-Z].*240[+])/) > 0){
          let parts = context.serial_input.substr(26).split(/(10[A-Z].*240[+])/)
          context.serial_input = parts[0] + '+' + parts[2]
        // other QR codes
        } else {
          context.serial_input = context.serial_input.split(',')[0]
        }
      }
      context.serial_input = context.serial_input.replaceAll('¡','+')
      // if (this.serial_input.trim() == '') return
      for (let p of list) {
        p.batchs.find((i) => {
          if (Boolean(i.serials))
            if (i.serials.includes(this.serial_input)) {
              this.serial_index = i.serials.indexOf(this.serial_input)
              this.batch_found_by_serial = i.batch
              this.serial_found = true
            }
        })
        if (this.serial_found) {
          this.$refs['serial_input'].focus()
          this.item_found_by_serial = p
          this.searching_serial = false
          break
        }
      }
      this.searching_serial = false
      this.$refs['serial_input'].focus()
    },
    playSound() {
      this.audio.play()
    },
    processInput(value){
      console.log("value: ", value)
    }
  },
}
</script>

<template>
  <div>
    <b-card v-if="inventory_count_mode" @click="$refs['serial_input'].focus()">
      <!-- <b-card-title>Conteo: </b-card-title> -->
      <b-input-group size="sm">
        <b-input-group-prepend class="lead mr-2">
          Serial:
        </b-input-group-prepend>
        <b-form-input
          v-model="serial_input"
          autofocus
          ref="serial_input"
          @keyup.enter.prevent="addItemInStockBySerialProccess()"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            @click="addItemInStockBySerialProccess()"
            size="sm"
            variant="outline-info"
          >
            <i class="fas fa-plus"></i>
            Agregar
          </b-button>
          <b-button
            @click="addManualSerial()"
            size="sm"
            class="d-none"
            variant="outline-warning">
            Manual
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <!-- <b-button
        @click="modalQrShow = !modalQrShow"
        variant="outline-info"
        class="mt-2"
      >
        <i class="fas fa-qrcode"></i>
        Lector QR
      </b-button> -->
      <!-- <b-button variant="outline-primary" @click="playSound()">ply</b-button> -->
    </b-card>

    <b-modal v-model="modalQrShow" @hidden="resetModalQr()">
      listo para scanear:
      <b-badge v-if="scan" href="#" variant="success">Listo</b-badge>
      <b-spinner v-else type="grow" label="Loading..."></b-spinner>

      <h4> Código QR: </h4>
      <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded">
      </StreamBarcodeReader>
      <div class="row">
        <div class="col-lg-12">
          <b-list-group>
            <b-list-group-item> Codigo: {{ qr.text }} </b-list-group-item>
            <b-list-group-item>
              Longitud: {{ qr.text.length }}
            </b-list-group-item>
            <b-list-group-item>
              Serial: {{ qr.text.split(',')[0] }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>
